import { render, staticRenderFns } from "./team-audit.vue?vue&type=template&id=52fc5fe2&scoped=true&"
import script from "./team-audit.vue?vue&type=script&lang=js&"
export * from "./team-audit.vue?vue&type=script&lang=js&"
import style0 from "./team-audit.vue?vue&type=style&index=0&id=52fc5fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc5fe2",
  null
  
)

export default component.exports